import { useEffect } from 'react';
import { getCurrentTenantGscTag, isGscVerificationEnabled } from '../../config/gscConfig';

/**
 * Google Search Console Verification Component (Direct Head Manipulation)
 * 
 * This component directly manipulates the document head to inject GSC verification meta tags.
 * It's an alternative to react-helmet that works with any React setup.
 */
const GscVerificationHead = () => {
  useEffect(() => {
    // Get the GSC tag for current tenant
    const currentTag = getCurrentTenantGscTag();
    const enabled = isGscVerificationEnabled();

    if (!enabled || !currentTag) {
      console.log(`GSC Verification not configured for tenant: ${window.location.hostname}`);
      return;
    }

    // Check if meta tag already exists
    const existingMeta = document.querySelector('meta[name="google-site-verification"]');
    
    if (existingMeta) {
      // Update existing meta tag
      existingMeta.setAttribute('content', currentTag);
      console.log(`GSC Verification updated for tenant: ${window.location.hostname}`);
    } else {
      // Create new meta tag
      const metaTag = document.createElement('meta');
      metaTag.setAttribute('name', 'google-site-verification');
      metaTag.setAttribute('content', currentTag);
      
      // Insert into head
      document.head.appendChild(metaTag);
      console.log(`GSC Verification added for tenant: ${window.location.hostname}`);
    }

    console.log(`GSC Tag: ${currentTag}`);

    // Cleanup function (optional - meta tags are safe to leave in DOM)
    return () => {
      // Only remove if we created it and component unmounts
      // In practice, we usually want to keep the meta tag
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default GscVerificationHead; 